import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { catchError, tap } from 'rxjs/operators';
import { DeveloperDto } from '@dto';
import { GenericOldService } from './generic-old.service';
import { GlobalAlertService } from './global-alert.service';

@Injectable({ providedIn: 'root' })
export class DeveloperService {
  private _developers: DeveloperDto[] = [];
  get developers(): DeveloperDto[] {
    return this._developers;
  }

  private readonly developersEmitter = new Subject<DeveloperDto[]>();
  private readonly searchFilterEmitter = new Subject<string>();

  constructor(
    private resourceService: GenericOldService<DeveloperDto>,
    private alertService: GlobalAlertService,
  ) {}

  getDevelopers$(): Observable<DeveloperDto[]> {
    return fromPromise<DeveloperDto[]>(
      this.resourceService.getTree(['developer', 'account', 'site']) as Promise<DeveloperDto[]>,
    ).pipe(
      tap(developers => {
        this.developersEmitter.next(developers);
        this._developers = [...developers];
      }),
      catchError((error: unknown) => {
        this.alertService.setError(error.toString());
        this.developersEmitter.error(error);
        return throwError(() => new Error(error.toString()));
      }),
    );
  }

  sendValue(value: string): void {
    this.searchFilterEmitter.next(value);
  }
}
